/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <!-- <group-room-list v-if="isGroup && !storeId"/> -->
    <store-room-calendar />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GroupRoomList from './GroupRoomList'
  import StoreRoomCalendar from './StoreRoomCalendar'

  export default {
    name: 'RoomCalendar',
    components: { GroupRoomList, StoreRoomCalendar },
    computed: {
      ...mapGetters(['isGroup']),
      storeId() { return this.$route.query.store },
    }
  }
</script>
